// Cisco product catalogue + control mappings. Data lives in
// ./cisco-products.json — edit that file (not this loader) to add
// products, change URLs, edit rationales, or remap controls.
// `pnpm validate:config` enforces consistency.

import data from "./cisco-products.json";
import type { CiscoProduct, CiscoProductMapping } from "../shared/types";

type RawProduct = CiscoProduct;
type RawMapping = { productId: string; rationale: string; howItHelps?: string };
type RawData = {
  products: Record<string, RawProduct>;
  mappings: Record<string, RawMapping[]>;
};

const TYPED = data as unknown as RawData;

export const CISCO_PRODUCTS: Record<string, CiscoProduct> = TYPED.products;

export const CISCO_PRODUCT_MAPPINGS: Record<string, CiscoProductMapping[]> =
  Object.fromEntries(
    Object.entries(TYPED.mappings).map(([controlId, entries]) => [
      controlId,
      entries
        .map((e): CiscoProductMapping | null => {
          const product = TYPED.products[e.productId];
          if (!product) return null;
          return {
            product,
            rationale: e.rationale,
            howItHelps: e.howItHelps,
          };
        })
        .filter((m): m is CiscoProductMapping => m !== null),
    ]),
  );

export function getCiscoMappings(controlId: string): CiscoProductMapping[] {
  return CISCO_PRODUCT_MAPPINGS[controlId] ?? [];
}
